<script lang="ts">
  import type { Snippet } from 'svelte';

  interface Props {
    title?: string;
    count?: number;
    actions?: Snippet;
    children: Snippet;
  }

  let { title, count, actions, children }: Props = $props();
</script>

<article class="card">
  {#if title}
    <header class="card-header">
      <h2>
        {title}
        {#if count !== undefined}<span class="count">{count}</span>{/if}
      </h2>
      {#if actions}<div class="actions">{@render actions()}</div>{/if}
    </header>
  {/if}
  {@render children()}
</article>

<style>
  .card {
    background: var(--surface-card);
    border: 1px solid var(--border-subtle);
    border-radius: var(--radius-lg);
    padding: var(--space-4) var(--space-5);
    display: flex;
    flex-direction: column;
    gap: var(--space-3);
  }
  .card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-3);
  }
  h2 {
    font-size: 14px;
    font-weight: 600;
    margin: 0;
    display: flex;
    align-items: center;
    gap: var(--space-2);
  }
  .count {
    font-size: 11px;
    color: var(--text-tertiary);
    background: var(--bg-hover);
    border-radius: var(--radius-sm);
    padding: 0 var(--space-2);
  }
  .actions {
    display: flex;
    gap: var(--space-2);
  }
</style>
